// src/components/strumenti/LeggeOhm.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

const COPPIE = [
  { id:"vi", label:"Tensione (V) e Corrente (A)", campi:["v","i"] },
  { id:"vr", label:"Tensione (V) e Resistenza (Ω)", campi:["v","r"] },
  { id:"vp", label:"Tensione (V) e Potenza (W)", campi:["v","p"] },
  { id:"ir", label:"Corrente (A) e Resistenza (Ω)", campi:["i","r"] },
  { id:"ip", label:"Corrente (A) e Potenza (W)", campi:["i","p"] },
  { id:"rp", label:"Resistenza (Ω) e Potenza (W)", campi:["r","p"] },
];
const LABEL = { v:"Tensione V (V)", i:"Corrente I (A)", r:"Resistenza R (Ω)", p:"Potenza P (W)" };

export default function LeggeOhm() {
  const [coppia, setCoppia] = useState("vi");
  const [valori, setValori] = useState({});

  const conf = COPPIE.find(c=>c.id===coppia);
  const val = k => leggiNumero(valori[k])||0;
  const set = (k,v) => setValori(o=>({...o,[k]:v}));

  let V=null, I=null, R=null, P=null;
  const a = val(conf.campi[0]), b = val(conf.campi[1]);
  const valido = a>0 && b>0;

  if (valido) {
    if (coppia==="vi") { V=a; I=b; R=V/I; P=V*I; }
    else if (coppia==="vr") { V=a; R=b; I=V/R; P=V*I; }
    else if (coppia==="vp") { V=a; P=b; I=P/V; R=V/I; }
    else if (coppia==="ir") { I=a; R=b; V=I*R; P=V*I; }
    else if (coppia==="ip") { I=a; P=b; V=P/I; R=V/I; }
    else if (coppia==="rp") { R=a; P=b; I=Math.sqrt(P/R); V=I*R; }
  }

  const fmt = n => n===null ? "—" : n.toLocaleString("it-IT",{maximumFractionDigits:3});

  return (
    <div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Grandezze note</label>
        <select value={coppia} onChange={e=>{setCoppia(e.target.value);setValori({});}} style={inp}>
          {COPPIE.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
        </select>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        {conf.campi.map(campo => (
          <div key={campo}>
            <label style={lbl}>{LABEL[campo]}</label>
            <input value={valori[campo]||""} onChange={e=>set(campo,e.target.value)} style={inp} placeholder="Es. 10"/>
          </div>
        ))}
      </div>

      <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8 }}>
          {[["V","V",V],["I","A",I],["R","Ω",R],["P","W",P]].map(([sim,unita,valore]) => (
            <div key={sim} style={{textAlign:"center"}}>
              <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>{sim}</div>
              <div style={{ fontSize:16, fontWeight:800, color:"#7c3aed" }}>{fmt(valore)}</div>
              <div style={{ fontSize:10, color:"#9ca3af" }}>{unita}</div>
            </div>
          ))}
        </div>
      </div>

      <button onClick={()=>setValori({})}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
